import React from 'react'
import styled from 'styled-components'
import media from 'css-in-js-media'

import { FullAbsolute } from '../styles/Utils'
import { H5 } from './Typography'
import Img from 'gatsby-image'
import { Variables } from '../styles/Variables'

const Wrapper = styled.div`
    position: relative;

    ${media('<desktop')} {
        height: 663px;
    }
`

const Content = styled.div`
    position: absolute;    
    left: 50%;    
    z-index: 20;
    color: ${Variables.color.white};
    bottom: 50px;
    transform: translateX(-50%);

    ${media('<desktop')} {
        bottom: 20px;
    }

    ${H5} {
        color: ${Variables.color.white};
    }
`

const Subtitle = styled.div`
    color: ${Variables.color.white};
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
`

const BackgroundImage = styled.div`
    ${media('<desktop')} {
        ${FullAbsolute}
        .gatsby-image-wrapper {
            height: 100%;
        }
        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }
    :before {
        content: '';
        ${FullAbsolute}
        top: auto;
        height: 300px;
        z-index: 10;
        pointer-events: none;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
    }
`


const AmenitiesSlide = ({
    title,
    subtitle,
    image,
    children,
}: {
    title: string
    subtitle: string
    image: string
    children?: object
}) => {
    return (
        <Wrapper>
            <Content>
                {image?.title && <Subtitle>{image?.title}</Subtitle>}
            </Content>
            {children}
            <BackgroundImage>
                <Img fluid={image.thumb} />
            </BackgroundImage>
        </Wrapper>
    )
}

export default AmenitiesSlide
